import React, { Suspense, useRef, useEffect, useState, useMemo } from 'react'
import { Canvas } from '@react-three/fiber'
import { useLocation, useHistory } from 'react-router-dom';
import { OrbitControls, PerspectiveCamera, Stage, useProgress } from '@react-three/drei'
import { Physics } from "@react-three/cannon";
import { getTestingstageTaskOnTask } from '../../src/api/chatApi/chatApi'
import Woman1 from "./models/Woman";
// import Pacient from "./models/Pacient";
import Pregnant from "./models/Pregnant_A";
import Aim from "./models/Blend_anim";
import Man1 from './models/Young_male_animation';
import PregnantOld from './models/PregnantBAnim';
import ManOld from './models/PACIENT_B';
import ManTif from './models/Pacient_TIF_ANIM';
// import { BoyAnimKrivoi } from './models/Boy_5year_ANIM_KRASNUHA';
import { Boy5 } from './models/Boy_5year_ANIMATION1';
import { Boy11 } from './models/BOY_11_years_EXPORT';
import { Girl5Months } from './models/Girl_5_monthsAnim';
// import { Katya } from './models/Katya_scene';
import { MiddleWoman } from './models/Middle_age_woman';
import { Sasha } from './models/SASHA_1_RIG';
import { Women16 } from './models/Wman16_22042021_anim';
import { Girl14 } from './models/Girl_22022022';
import { ProgressBar, Modal as CarbonModal } from '@carbon/react';
import CustomButton from '../components/common/CustomButton';
import useIncreaseTaskStage from '../hooks/testingTask/useIncreaseTaskStage';
import { RoutePath } from '../types';
import chatApi from '../api/chatApi';
import RatingDialog from '../components/Chat/RatingDialog';
import useTestingStage from '../hooks/testingTask/useTestingStage';
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  InputLabel,
  MenuItem,
  Select
} from '@material-ui/core';
import './index.css'
import { usePointProcentStore } from '../../src/pages/chat/store'
import ManInsult from './models/ManInsult';
import NeuroManNTrue from './models/Neurologia_man_normostenik2';
import NeuroWomNTrue from './models/Neurologia_wom_normostenik';
import WomanJaundice from './models/Woman_jaundice';
import WomInsult from './models/WomInsult';
import WomanOld from './models/WomanOld';
import WomanAtrophy from './models/Middle_age_woman_atrophy';
import WomanMastectomy from './models/Woman_mastectomy';
import BaldMan from './models/Blend_20052024';
import Man2 from './models/Youngmale_30072024';
import OldMaleM from './models/Oldmale_mezomorph_Patient';
import YoungMale from './models/Youngmale_3_vasculit';
import FatMan from './models/Oldmale_endomorph_travmatologya2';
import ManWhiteShirt from './models/PACIENT_A_15102024_ANIM';
import OldDeath from './models/Oldmale_mezomorph_Patient_Death2';
import Boy11New from './models/BOY_11_years_animation20122024';
import BoyNoShirt from './models/BOY_20122024';
import Boy_5year_clearskin from './models/Boy_5year_clearskin';
import Boy_5year_krasnuha from './models/Boy_5year_krasnuha';
import useNextStageInfo from '../hooks/testingTask/useNextStageInfo';
import useHasDifferentiatedDiagnosis from '../hooks/useHasDifferentiatedDiagnosis';
import OldDeath2 from './models/Oldmale_endomorph_DEATH';


const Model = ({
  type,
  embedded = false,
  expanded = false,
  markers = [],
  onCreateMarker,
  onSelectMarker,
  taskTaskProceedId
}) => {
  const MARKER_RADIUS = 0.035
  const ref = useRef()
  const containerRef = useRef(null)
  const [eventSourceEl, setEventSourceEl] = useState(null)
  const lastCreateTsRef = useRef(0)
  const getPointProcent = usePointProcentStore(state => state.getPoints)
  const hasDifferentiatedDiagnosis = useHasDifferentiatedDiagnosis()
  const noopSetAnim = useMemo(() => () => {}, [])
  const embeddedCameraPosition = useMemo(() => {
    if (!embedded) return [0, 2, 5]
    return expanded ? [0, 1.7, 3.7] : [0, 2, 5]
  }, [embedded, expanded])


  useEffect(() => {
    if (containerRef.current && eventSourceEl !== containerRef.current) {
      setEventSourceEl(containerRef.current)
    }
  }, [eventSourceEl])

  ///////////////// Переход на следующий этап
  const nextStage = useNextStageInfo()
  const [status, setStatus] = useState(false)
  const [openRating, setOpenRating] = React.useState(false)
  const [anim, setAnim] = useState([])
  const [indexAnim, setIndexAnim] = useState(0)
  const [isEmbeddedModelReady, setIsEmbeddedModelReady] = useState(false)
  const [stages, setStages] = useState([]);
  const { routhPathCode, activeStage } = useNextStagePath(stages);
  const [increaseLoading, increase, setAsyncTaskStage] = useIncreaseTaskStage(nextStage?.routePath, nextStage?.activateStage)
  const [increaseLoadingOwnStage, increaseOwnStage, setAsyncTaskOwnStage] = useIncreaseTaskStage(RoutePath[routhPathCode], activeStage)
  const testingStage = useTestingStage()
  const location = useLocation();
  const history = useHistory();
  const currentStageTask = useMemo(() => {
    return stages.find(stage => stage.routePath === location.pathname)
  }, [stages, location.pathname])

  // Функция для перехода на следующий этап, если текущий этап уже пройден
  async function goToNextStage() {
    const currentPath = location.pathname;
    const currentStageObj = stages.find(stage => stage.routePath === currentPath);
    if (!currentStageObj) return;

    setHistoryStage(currentStageObj.activeStage)
    const currentActiveStage = currentStageObj.activeStage;

    // Найти следующий этап с наименьшим activeStage, который больше текущего activeStage
    const nextStageObj = stages
      .filter(stage => stage.activeStage > currentActiveStage)
      .sort((a, b) => a.activeStage - b.activeStage)[0];

      if (nextStageObj && nextStageObj.legend_id) {
        history.push(RoutePath.legend);
      } else if (nextStageObj) {
        history.push(nextStageObj.routePath);
      }
  }

  // Функция для получения этапов
  async function fetchAllStages() {
    try {
      const result = await getTestingstageTaskOnTask();
      setStages(result.data.testingstage_task_on_task);
    } catch (error) {
      console.error('Ошибка при загрузке этапов:', error);
    }
  }

  useEffect(() => {
    if (embedded) return
    fetchAllStages();
  }, [embedded]);

  function useNextStagePath(stages) {
    const location = useLocation();
    const currentPath = location.pathname;

    return useMemo(() => {
      if (!stages || stages.length === 0) {
        return { routePath: '', routhPathCode: '' };
      }
      const sortedStages = stages.sort((a, b) => a.activeStage - b.activeStage);
      const currentIndex = sortedStages.findIndex(stage => stage.routePath === currentPath);

      if (currentIndex !== -1 && currentIndex + 1 < sortedStages.length) {
        return {
          routePath: sortedStages[currentIndex + 1].routePath,
          routhPathCode: sortedStages[currentIndex + 1].routhPathCode,
          activeStage: sortedStages[currentIndex + 1].activeStage
        };
      }

      return { routePath: '', routhPathCode: '' };
    }, [stages, currentPath]);
  }

  useEffect(() => {
    if (embedded) return
    const getDialogStatus = async () => {
      try {
        const response = await chatApi.getSettingsPiloting();
        const statusValue = response.result[0].value;

        setStatus(statusValue === 'true');
      } catch (error) {
        console.log(error)
      }

    };

    getDialogStatus();
    setAsyncTaskStage()
  }, [embedded, setAsyncTaskStage]);

  const [manualActiveStage, setManualActiveStage] = useState(false)
  const [isLoadingBtn, setIsLoadingBtn] = useState(false)

  async function getHistoryStage() {
    setIsLoadingBtn(true)
    try {
      const res = await chatApi.getTestingStageHistory()
      const result = res.result.find((el) => el.activeStageId === 1)
      if (result && (!stages || stages.length === 0)) {
        setManualActiveStage(true)
      }
      setIsLoadingBtn(false)

    } catch (error) {
      console.log(error)
      setIsLoadingBtn(false)
    }
  }

  async function setHistoryStage(testingStage) {
    try {
      const res = await chatApi.setTestingStageHistory(testingStage)
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    if (embedded) return
    getHistoryStage()
  }, [embedded])


  function showRatingDialog() {
    if (stages) {
      goToNextStage()
    } else {
      setHistoryStage(1)
      setIndexAnim(0)
      increase()
      if (status) {
        setOpenRating(true)
      }
    }
  }


  function hideRatingDialog() {
    setHistoryStage(1)
    if (routhPathCode) {
      increaseOwnStage()
    } else {
      increase()
    }
    // setAsyncTaskStage()
  }
 

  const [openMenu, setOpenMenu] = useState(false)
  const [openModal, setOpenModal] = useState(false)
  const [openModal2, setOpenModal2] = useState(false)
  const [difDiagnosisOptions, setDifDiagnosisOptions] = useState([])
  const [selectedDifDiagnosisId, setSelectedDifDiagnosisId] = useState('')
  const [difDiagnosisTaskId, setDifDiagnosisTaskId] = useState(null)
  const [difDiagnosisLoading, setDifDiagnosisLoading] = useState(false)
  const [difDiagnosisSaving, setDifDiagnosisSaving] = useState(false)
  const [test, setTest] = useState(0)
  const [refRom1, setRom1] = useState([])
  const [refRom2, setRom2] = useState([])
  const [refs, setRefs] = useState([])
  const [mim, setMim] = useState([])
  const [cor, setCor] = useState([])
  const [refLas, setLas] = useState([])

  const normalizeDifDiagnosisList = (res) => {
    const raw = res?.result
    if (Array.isArray(raw)) return raw
    if (Array.isArray(raw?.result)) return raw.result
    return []
  }

  const normalizeDifDiagnosisTaskList = (res) => {
    const raw = res?.result
    if (Array.isArray(raw)) return raw
    if (Array.isArray(raw?.result)) return raw.result
    return []
  }

  const extractTaskIdFromResult = (taskResult) => {
    if (taskResult == null) return null
    if (typeof taskResult === 'number') return taskResult
    if (typeof taskResult === 'object') {
      const id = taskResult?.id ?? taskResult?.taskDifferentiatedDiagnosisId ?? taskResult?.task_differentiated_diagnosis_id
      return id == null ? null : id
    }
    return null
  }

  const extractSelectedDifDiagnosisIdFromResult = (taskResult, optionsList) => {
    if (taskResult == null) return ''

    if (typeof taskResult === 'number') {
      const match = (optionsList || []).find((o) => String(o?.id) === String(taskResult))
      return match ? String(match.id) : ''
    }

    if (typeof taskResult === 'object') {
      const id =
        taskResult?.differentiatedDiagnosisId ??
        taskResult?.differentiatedDiagnosis?.id ??
        taskResult?.differentiatedDiagnosis?.differentiatedDiagnosisId

      if (id != null) return String(id)

      const diagnosisText =
        taskResult?.differentiatedDiagnosis?.differentiatedDiagnosis ??
        taskResult?.differentiatedDiagnosis?.name ??
        taskResult?.differentiatedDiagnosis

      if (diagnosisText) {
        const matchByText = (optionsList || []).find(
          (o) => String(o?.differentiatedDiagnosis) === String(diagnosisText)
        )
        return matchByText ? String(matchByText.id) : ''
      }
    }

    return ''
  }

  const fetchDifDiagnosisModalData = async () => {
    if (!taskTaskProceedId) return
    if (!currentStageTask?.testingstage_id) return

    setDifDiagnosisLoading(true)
    setDifDiagnosisTaskId(null)
    setSelectedDifDiagnosisId('')
    try {
      const [allRes, allTasksRes] = await Promise.all([
        chatApi.getDifDiagnosisAll(),
        chatApi.getDifDiagnosisCurrentTask()
      ])

      const list = normalizeDifDiagnosisList(allRes)
      setDifDiagnosisOptions(list)

      const allTasks = normalizeDifDiagnosisTaskList(allTasksRes)
      const currentTask = allTasks.find((t) => {
        const proceedOk = String(t?.userTaskProceedId) === String(taskTaskProceedId)
        const stageOk = String(t?.testingStageId) === String(currentStageTask.testingstage_id)
        return proceedOk && stageOk
      })

      const nextTaskId = extractTaskIdFromResult(currentTask)
      setDifDiagnosisTaskId(nextTaskId)

      const nextSelectedId = extractSelectedDifDiagnosisIdFromResult(currentTask, list)
      if (nextSelectedId) setSelectedDifDiagnosisId(nextSelectedId)
    } catch (e) {
      console.log(e)
    } finally {
      setDifDiagnosisLoading(false)
    }
  }

  useEffect(() => {
    if (!openModal2) return
    fetchDifDiagnosisModalData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openModal2, taskTaskProceedId, currentStageTask?.testingstage_id])

  const handleSaveDifDiagnosisTask = async () => {
    const selected = difDiagnosisOptions.find((o) => String(o?.id) === String(selectedDifDiagnosisId))
    if (!selected || !selected?.id) return
    if (!currentStageTask?.testingstage_id) return

    const payload = {
      answerVal: null,
      answerValId: null,
      differentiatedDiagnosis: {
        differentiatedDiagnosis: selected.differentiatedDiagnosis,
        id: selected.id
      },
      differentiatedDiagnosisId: selected.id,
      id: difDiagnosisTaskId ?? null,
      questionVal: null,
      questionValId: null,
      testingStageId: currentStageTask.testingstage_id,
      userTaskProceedId: null
    }

    setDifDiagnosisSaving(true)
    try {
      if (difDiagnosisTaskId != null) {
        await chatApi.updateDifDiagnosisTask(payload)
      } else {
        await chatApi.createDifDiagnosisTask(payload)
      }
      await fetchDifDiagnosisModalData()
    } catch (e) {
      console.log(e)
    } finally {
      setDifDiagnosisSaving(false)
      setOpenModal2(false)
    }
  }

  useEffect(() => {
    if (!embedded) return
    if (anim.length > 0) {
      setIsEmbeddedModelReady(true)
    }
  }, [embedded, anim])

  useEffect(() => {
    if (!embedded) return
    setIsEmbeddedModelReady(false)
  }, [embedded, type])

  function LoaderOverlay() {
    const { progress, active } = useProgress()
    const visible = embedded
      ? !isEmbeddedModelReady && (active || progress < 100)
      : active || progress < 100

    if (!visible) return null

    return (
      <div
        style={{
          position: 'absolute',
          top: 20,
          left: 0,
          right: 0,
          zIndex: 5,
          display: 'flex',
          justifyContent: 'center',
          pointerEvents: 'none',
          transition: 'opacity 180ms ease'
        }}
      >
        <div
          style={{
            width: '100%',
            maxWidth: 460,
            margin: '0 24px',
            padding: '12px 16px',
            borderRadius: 12,
            background: 'rgba(20, 21, 34, 0.86)',
            boxShadow: '0 10px 30px rgba(0, 0, 0, 0.22)',
            backdropFilter: 'blur(6px)'
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 10 }}>
          <div style={{ color: '#fff', fontSize: 16, fontWeight: 500 }}>Загрузка 3D модели</div>
          <div style={{ color: '#fff', fontSize: 16 }}>{Math.round(progress)} %</div>
        </div>

        <ProgressBar
          label='Загрузка 3D модели'
          value={progress}
          size='big' status='active' />
        </div>
      </div>
    )
  }


  useEffect(() => {
    if (embedded) return

    if (anim.length > 0) {
      if (type !== 'ManInsult' && type !== 'WomInsult') {
        const data = anim.findIndex(el => el.name === 'stand')
        setIndexAnim(data)
      }


      if (type === 'ManInsult' || type === 'WomInsult') {
        const data = anim.findIndex(el => el.name === 'lying')
        setIndexAnim(data)
      }
    }


    const rom1 = anim.filter(el => {
      if (el.name) {
        return el.name.includes("1_R")
      }
    })
    const rom2 = anim.filter(el => {
      if (el.name) {
        return el.name.includes("2_R")
      }
    })
    const ref = anim.filter(el => {
      if (el.name) {
        return el.name.includes("3_")
      }
    })
    const mim = anim.filter(el => {
      if (el.name) {
        return el.name.includes("4_")
      }
    })
    const las = anim.filter(el => {
      if (el.name) {
        return el.name.includes("5_")
      }
    })
    const cor = anim.filter(el => {
      if (el.name) {
        return el.name.includes("6_")
      }
    })
    setRom1(rom1)
    setRom2(rom2)
    setRefs(ref)
    setMim(mim)
    setCor(cor)
    setLas(las)
  }, [embedded, anim, type]);

  useEffect(() => {
    if (embedded) return
    getPointProcent()
  }, [embedded, getPointProcent])

  const setAnimHandler = embedded ? noopSetAnim : setAnim

  const typeAnim = (el) => {
    switch (el) {
      //РОМ1
      case '1_Romberg_test1L':
        return 'Проверка рефлекса левая рука Р1';
      case '1_Romberg_test1R':
        return 'Проверка рефлекса правой руки Р1';
      case '1_Romberg_test2L':
        return 'Проверка рефлекса левой ноги Р1';
      case '1_Romberg_test2R':
        return 'Проверка рефлекса правой ноги Р1';
      //РОМ2
      case '2_Romberg_test1L':
        return 'Проверка рефлекса левой руки Р2';
      case '2_Romberg_test1R':
        return 'Проверка рефлекса правой руки Р2';
      //Глубокие
      case '3_ahillesL':
        return 'ахиллов рефлекс лево';
      case '3_ahillesR':
        return 'ахиллов рефлекс право';
      case '3_reflex1L':
        return 'коленный рефлекс лево';
      case '3_reflex1R':
        return 'коленный рефлекс право';
      case '3_bicepsL':
        return 'Бицепс-рефлекс лево';
      case '3_bicepsR':
        return 'Бицепс-рефлекс право';
      case '3_reflex2L':
        return 'Карпо-радиальный рефлекс лево';
      case '3_reflex2R':
        return 'Карпо-радиальный рефлекс право';
      //Мимика
      case '4_moveEyes_1':
        return 'движения глаз лево-право';
      case '4_moveEyes_2':
        return 'движения глаз вверх-вниз';
      case '4_face1':
        return 'зубы, хоботковый рефлекс';
      case '4_face2':
        return 'показать язык';
      case '4_face3':
        return 'морщит нос';
      case '4_meningeal':
        return 'менингеальные симптомы';
      //Ласега
      case '5_lasegaL':
        return 'симптом Ласега левая нога';
      case '5_lasegaR':
        return 'симптом Ласега правая нога';
      //Коорд
      case '6_coordinationL':
        return 'Левая рука (касается кончика носа)';
      case '6_coordinationR':
        return 'Правая рука (касается кончика носа)';
      default:
        return 'Нет подписи';
    }
  }

  const getAnim = (data, type) => {
    if (type === 'rom1') {
      const index = anim.findIndex(el => el.name === data)
      setIndexAnim(index)
      const reset = anim.findIndex(el => el.name === 'Romberg1_pose')
      const timerId = setTimeout(() => {
        setIndexAnim(reset)
        clearTimeout(timerId)
      }, 5000)
    }

    else if (type === 'rom2') {
      const index = anim.findIndex(el => el.name === data)
      setIndexAnim(index)
      const reset = anim.findIndex(el => el.name === 'Romberg2_pose')
      const timerId = setTimeout(() => {
        setIndexAnim(reset)
        clearTimeout(timerId)
      }, 5000)

    }

    else if (type === 'refs') {
      const index = anim.findIndex(el => el.name === data)
      setIndexAnim(index)

      const reset = anim.findIndex(el => el.name === 'sit_idle')
      const timerId = setTimeout(() => {
        setIndexAnim(reset)
        clearTimeout(timerId)
      }, 5000)
    }

    else if (type === 'mim') {
      const index = anim.findIndex(el => el.name === data)
      setIndexAnim(index)
      const reset = anim.findIndex(el => el.name === 'sit_idle')
      const timerId = setTimeout(() => {
        setIndexAnim(reset)
        clearTimeout(timerId)
      }, 5000)
    }

    else if (type === 'cor') {
      const index = anim.findIndex(el => el.name === data)
      setIndexAnim(index)
      const reset = anim.findIndex(el => el.name === 'lying')
      const timerId = setTimeout(() => {
        setIndexAnim(reset)
        clearTimeout(timerId)
      }, 5000)
    }

    else if (type === 'las') {
      const index = anim.findIndex(el => el.name === data)
      setIndexAnim(index)
      const reset = anim.findIndex(el => el.name === 'lying')
      const timerId = setTimeout(() => {
        setIndexAnim(reset)
        clearTimeout(timerId)
      }, 5000)
    }

  }

  const resetAnim = (data) => {
    setTest(0)

    //Простые
    if (data === 'rom1') {
      const data = anim.findIndex(el => el.name === 'Romberg1_output')
      setIndexAnim(data)
      const reset = anim.findIndex(el => el.name === 'stand')
      const resetIns = anim.findIndex(el => el.name === 'lying')
      const timerId = setTimeout(() => {
        setIndexAnim(type !== 'WomInsult' && type !== 'ManInsult' ? reset : resetIns)
        clearTimeout(timerId)
      }, 5000)
    }

    else if (data === 'rom2') {
      const data = anim.findIndex(el => el.name === 'Romberg2_output')
      setIndexAnim(data)
      const reset = anim.findIndex(el => el.name === 'stand')
      const resetIns = anim.findIndex(el => el.name === 'lying')
      const timerId = setTimeout(() => {
        setIndexAnim(type !== 'WomInsult' && type !== 'ManInsult' ? reset : resetIns)
        clearTimeout(timerId)
      }, 5000)
    }


    else if (data === 'refs' || data === 'mim') {
      const data = anim.findIndex(el => el.name === 'stand')
      setIndexAnim(data)
      const reset = anim.findIndex(el => el.name === 'stand')
      const resetIns = anim.findIndex(el => el.name === 'lying')
      const timerId = setTimeout(() => {
        setIndexAnim(type !== 'WomInsult' && type !== 'ManInsult' ? reset : resetIns)
        clearTimeout(timerId)
      }, 5000)
    }

    //Инсульт
    else if (type !== 'WomInsult' && type !== 'ManInsult' && data === 'cor') {
      const data = anim.findIndex(el => el.name === 'lying_standUP')
      setIndexAnim(data)
      const reset = anim.findIndex(el => el.name === 'stand')
      const timerId = setTimeout(() => {
        setIndexAnim(reset)
        clearTimeout(timerId)
      }, 5000)
    }

    else if (type !== 'WomInsult' && type !== 'ManInsult' && data === 'las') {
      const data = anim.findIndex(el => el.name === 'lying_standUP')
      setIndexAnim(data)
      const reset = anim.findIndex(el => el.name === 'stand')
      const timerId = setTimeout(() => {
        setIndexAnim(reset)
        clearTimeout(timerId)
      }, 5000)
    }



    else if (type === 'WomInsult' && type === 'ManInsult' && data === 'las') {
      const data = anim.findIndex(el => el.name === 'lying')
      setIndexAnim(data)
    }

    else if (type === 'WomInsult' && type === 'ManInsult' && data === 'cor') {
      const data = anim.findIndex(el => el.name === 'lying')
      setIndexAnim(data)
    }
  }




  const goRom1 = () => {
    if (type !== 'WomInsult' && type !== 'ManInsult') {
      const data = anim.findIndex(el => el.name === 'Romberg1_input')
      setIndexAnim(data)
    }
    else {
      const data = anim.findIndex(el => el.name === 'lying')
      setIndexAnim(data)
    }
    setTest(1)
  }

  const goRom2 = () => {
    if (type !== 'WomInsult' && type !== 'ManInsult') {
      const data = anim.findIndex(el => el.name === 'Romberg2_input')
      setIndexAnim(data)
    }
    else {
      const data = anim.findIndex(el => el.name === 'lying')
      setIndexAnim(data)
    }
    setTest(2)
  }

  const goRefs = () => {
    if (type !== 'WomInsult' && type !== 'ManInsult') {
      const data = anim.findIndex(el => el.name === 'sit_idle')
      setIndexAnim(data)
    }
    else {
      const data = anim.findIndex(el => el.name === 'lying')
      setIndexAnim(data)
    }
    setTest(3)
  }

  const goMim = () => {
    if (type !== 'WomInsult' && type !== 'ManInsult') {
      const data = anim.findIndex(el => el.name === 'sit_idle')
      setIndexAnim(data)
    }
    else {
      const data = anim.findIndex(el => el.name === 'lying')
      setIndexAnim(data)
    }
    setTest(4)
  }

  const goCor = () => {
    if (type !== 'WomInsult' && type !== 'ManInsult') {
      const data = anim.findIndex(el => el.name === 'stand_lie down')
      setIndexAnim(data)
      const reset = anim.findIndex(el => el.name === 'lying')
      const timerId = setTimeout(() => {
        setIndexAnim(reset)
        clearTimeout(timerId)
      }, 5000)
    }
    else {
      const data = anim.findIndex(el => el.name === 'lying')
      setIndexAnim(data)
    }
    setTest(5)
  }

  const goLas = () => {
    if (type !== 'WomInsult' && type !== 'ManInsult') {
      const data = anim.findIndex(el => el.name === 'stand_lie down')
      setIndexAnim(data)
      const reset = anim.findIndex(el => el.name === 'lying')
      const timerId = setTimeout(() => {
        setIndexAnim(reset)
        clearTimeout(timerId)
      }, 5000)
    }
    else {
      const data = anim.findIndex(el => el.name === 'lying')
      setIndexAnim(data)
    }
    setTest(6)
  }

  const tryCreateEmbeddedMarker = (event, force = false) => {
    if (!embedded || !onCreateMarker) {
      return
    }
    const pointFromIntersection = event?.point || event?.intersections?.[0]?.point

    if (!pointFromIntersection) {
      return
    }
    if (!force && !event?.nativeEvent?.detail) {
      return
    }

    const now = Date.now()
    const isDoubleByDetail = Number(event?.nativeEvent?.detail) >= 2
    const isDoubleByTime = now - lastCreateTsRef.current < 260
    const isAltClick = Boolean(event?.nativeEvent?.altKey)

    if (!force && !isDoubleByDetail && !isDoubleByTime && !isAltClick) {
      return
    }

    lastCreateTsRef.current = now
    event.stopPropagation()
    const localPoint =
      pointFromIntersection?.clone && event?.eventObject?.worldToLocal
        ? event.eventObject.worldToLocal(pointFromIntersection.clone())
        : pointFromIntersection

    onCreateMarker({
      x: Number(localPoint.x.toFixed(5)),
      y: Number(localPoint.y.toFixed(5)),
      z: Number(localPoint.z.toFixed(5))
    })
  }

  const buttonText = manualActiveStage ? 'Следующий этап' : "Завершить этап 'Осмотр'";
  

  return (
    <div
      ref={containerRef}
      style={{ 
        height: embedded ? '100%' : '100vh', 
        background: '#33334C', 
        borderRadius: 4, 
        position: 'relative',
        minHeight: embedded ? 'auto' : '500px'
      }}
    >
      {!embedded && openRating ? (
        <RatingDialog open={openRating} onSubmit={hideRatingDialog} />
      ) : null}
      
      {!embedded && (
        <div style={{ 
          position: 'fixed', 
          bottom: 20, 
          left: 100,
          right: 0,
          width: '100%', 
          zIndex: 9999, 
          display: 'flex', 
          justifyContent: 'center',
          pointerEvents: 'auto'
        }}>
          <div>
            {anim.length > 1 && type !== 'WomanOld' && (
              <>
                <Button 
                  aria-controls="simple-menu" 
                  aria-haspopup="true" 
                  style={{ color: 'white', background: '#1976d2', marginRight: '10px' }} 
                  onClick={() => setOpenMenu(prev => !prev)}
                >
                  Рефлексы
                </Button>
                <Button 
                  style={{ color: 'white', background: '#1976d2', marginRight: '10px' }} 
                  type="button" 
                  onClick={() => setOpenModal(true)}
                >
                  Помощь
                </Button>
              </>
            )}

          </div>
          <div style={{marginRight: '10px'}}>
              <CustomButton
                loading={increaseLoading}
                onClick={showRatingDialog}
                style={{ minWidth: '200px' }}
              >
                {buttonText}
              </CustomButton>
          </div>
          
          {hasDifferentiatedDiagnosis && (
          <div style={{marginRight: '10px'}}>
              <CustomButton
                loading={increaseLoading}
                onClick={() => setOpenModal2(true)}
                style={{ minWidth: '200px' }}
              >
                Симптом
              </CustomButton>
          </div>
          )}
        </div>
      )}

      <CarbonModal
        modalHeading="Помощь"
        passiveModal
        onRequestClose={() => setOpenModal(false)}
        open={openModal}
        hasScrollingContent
      >
        <p> Инструкция по работе с рефлексами
          Нажмите кнопку "Рефлексы", чтобы открыть список доступных для выполнения пациентом рефлексов. Нажимайте на кнопки наименования рефлексов, чтобы просмотреть действия пациента при выполнении данных рефлексов.
          Чтобы приблизить модель, прокрутите колесом мыши.
          Чтобы повернуть модель, используйте левую кнопку мыши.
          Чтобы переместить модель по горизонтали или вертикали, используйте правую кнопку мыши.
        </p>
      </CarbonModal>

      <Dialog
        open={openModal2}
        onClose={() => setOpenModal2(false)}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>Симптом</DialogTitle>
        <DialogContent dividers>
          <div style={{ display: 'flex', gap: 12, alignItems: 'flex-end', flexWrap: 'wrap' }}>
            <FormControl variant="outlined" size="small" style={{ minWidth: 320, flex: '1 1 320px' }}>
              <InputLabel id="dif-diagnosis-select-label">Симптом</InputLabel>
              <Select
                labelId="dif-diagnosis-select-label"
                value={selectedDifDiagnosisId}
                onChange={(e) => setSelectedDifDiagnosisId(String(e.target.value))}
                label="Симптом"
                disabled={difDiagnosisLoading || difDiagnosisSaving}
                MenuProps={{
                  disablePortal: true
                }}
              >
                <MenuItem value="">
                  <em>Выберите Симптом</em>
                </MenuItem>
                {difDiagnosisOptions.map((opt) => (
                  <MenuItem key={opt.id} value={String(opt.id)}>
                    {opt.differentiatedDiagnosis || `Диагноз ${opt.id}`}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
        </DialogContent>
        <DialogActions style={{ padding: '12px 24px' }}>
          <Button
            onClick={() => setOpenModal2(false)}
            disabled={difDiagnosisLoading || difDiagnosisSaving}
          >
            Закрыть
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={handleSaveDifDiagnosisTask}
            disabled={difDiagnosisLoading || difDiagnosisSaving || !selectedDifDiagnosisId}
            style={{ minWidth: 160 }}
          >
            {difDiagnosisSaving ? (
              <span style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>
                <CircularProgress size={18} color="inherit" />
                {difDiagnosisTaskId != null ? 'Обновление' : 'Сохранение'}
              </span>
            ) : (
              (difDiagnosisTaskId != null ? 'Обновить' : 'Сохранить')
            )}
          </Button>
        </DialogActions>
      </Dialog>

      <LoaderOverlay />
      
      <Suspense fallback={null}>
        {eventSourceEl ? (
          <Canvas
            style={{ height: '100%', width: '100%' }}
            eventSource={eventSourceEl}
          >
            <Stage
              environment={null}
              controls={ref}
              preset={{main:[0, 0, 3], fill: [1, 1, 1]}}
              intensity={0.3}
              shadows={{ type: 'accumulative', opacity: 0 }}
            >
              <Physics>
                <group
                  onPointerDown={(event) => tryCreateEmbeddedMarker(event)}
                  onDoubleClick={(event) => tryCreateEmbeddedMarker(event, true)}
                  onClick={(event) => tryCreateEmbeddedMarker(event)}
                >
                  {/* Модели */}
                  {type === 'Girl14' && <Girl14 setAnim={setAnimHandler} />}
                  {type === 'WomanEndomrph' && <Woman1 setAnim={setAnimHandler} />}
                  {type === 'Pregnant' && <Pregnant setAnim={setAnimHandler} />}
                  {type === 'Man' && <Aim setAnim={setAnimHandler} />}
                  {type === 'Woman' && <Women16 setAnim={setAnimHandler} />}
                  {type === 'ManYoung' && <Man1 setAnim={setAnimHandler} />}
                  {type === 'ManYoung2' && <Man2 setAnim={setAnimHandler} />}
                  {type === 'OldDeath2' && <OldDeath2 setAnim={setAnimHandler} />}
                  {type === 'PregnantOld' && <PregnantOld setAnim={setAnimHandler} />}
                  {type === 'OldMaleM' && <OldMaleM setAnim={setAnimHandler}/>}
                  {type === 'YoungMale' && <YoungMale setAnim={setAnimHandler}/>}
                  {type === 'FatMan' && <FatMan setAnim={setAnimHandler}/>}
                  {type === 'ManWhiteShirt' && <ManWhiteShirt setAnim={setAnimHandler} />}
                  {type === 'OldDeath' && <OldDeath setAnim={setAnimHandler}/>}
                  {type === 'ManOld' && <ManOld setAnim={setAnimHandler} />}
                  {type === 'BoyNoShirt' && <BoyNoShirt setAnim={setAnimHandler} />}
                  {type === 'Boy11New' && <Boy11New setAnim={setAnimHandler}/>}
                  {type === 'Boy_5year_clearskin' && <Boy_5year_clearskin setAnim={setAnimHandler} />}
                  {type === 'Boy_5year_krasnuha' && <Boy_5year_krasnuha setAnim={setAnimHandler} />}
                  {type === 'BaldMan' && <BaldMan setAnim={setAnimHandler} />}
                  {type === 'WomanOld' && <WomanOld setAnim={setAnimHandler} index={indexAnim} />}
                  {type === 'ManTif' && <ManTif setAnim={setAnimHandler} />}
                  {type === 'BoyKras' && <Boy5 setAnim={setAnimHandler} />}
                  {type === 'WomanAtrophy' && <WomanAtrophy setAnim={setAnimHandler} />}
                  {type === 'Boy11' && <Boy11 setAnim={setAnimHandler} />}
                  {type === 'ManInsult' && <ManInsult setAnim={setAnimHandler} index={indexAnim} />}
                  {type === 'WomInsult' && <WomInsult setAnim={setAnimHandler} index={indexAnim} />}
                  {type === 'Jaundice' && <WomanJaundice setAnim={setAnimHandler} />}
                  {type === 'WomanMastectomy' && <WomanMastectomy setAnim={setAnimHandler} />}
                  {type === 'NeuroManN' && <NeuroManNTrue setAnim={setAnimHandler} index={indexAnim} />}
                  {type === 'NeuroWomN' && <NeuroWomNTrue setAnim={setAnimHandler} index={indexAnim} />}
                  {type === 'Girl5Months' && <Girl5Months setAnim={setAnimHandler} />}
                  {type === 'MiddleWoman' && <MiddleWoman setAnim={setAnimHandler} />}
                  {type === 'Boy5Months' && <Sasha setAnim={setAnimHandler} />}
                  
                  {embedded && markers.map((marker) => {
                    const x = Number(marker?.point_x)
                    const y = Number(marker?.point_y)
                    const z = Number(marker?.point_z)
                    const isValid =
                      Number.isFinite(x) &&
                      Number.isFinite(y) &&
                      Number.isFinite(z) &&
                      Math.abs(x) <= 20 &&
                      Math.abs(y) <= 20 &&
                      Math.abs(z) <= 20

                    if (!isValid) return null

                    return (
                      <mesh
                        key={marker.id}
                        position={[x, y, z]}
                        onPointerOver={(e) => {
                          e.stopPropagation()
                          document.body.style.cursor = 'pointer'
                        }}
                        onPointerOut={(e) => {
                          e.stopPropagation()
                          document.body.style.cursor = 'auto'
                        }}
                        onClick={(e) => {
                          e.stopPropagation()
                          if (onSelectMarker) onSelectMarker(marker)
                        }}
                      >
                        <sphereGeometry args={[MARKER_RADIUS, 20, 20]} />
                        <meshStandardMaterial color="#2196F3" />
                      </mesh>
                    )
                  })}
                </group>
              </Physics>
            </Stage>

            <OrbitControls
              ref={ref}
              makeDefault
              maxDistance={embedded ? (expanded ? 6 : 8) : 1.2}
              minDistance={embedded ? (expanded ? 0.8 : 1) : 1.5}
              enableZoom={true}
              enableRotate={true}
              enablePan={embedded}
              zoomSpeed={2}
            />
            <PerspectiveCamera makeDefault fov={expanded ? 42 : 50} position={embeddedCameraPosition} />
          </Canvas>
        ) : (
          !embedded && (
            <div style={{ 
              display: 'flex', 
              justifyContent: 'center', 
              alignItems: 'center', 
              height: '100%',
              color: 'white'
            }}>
              Загрузка 3D сцены...
            </div>
          )
        )}
      </Suspense>

      {/* Блок с меню рефлексов - вынесен наружу для лучшей видимости */}
      {!embedded && openMenu && anim.length > 1 && (
        <div style={{
          position: 'fixed',
          bottom: '100px',
          left: '50%',
          transform: 'translateX(-50%)',
          zIndex: 9998,
          background: 'rgba(0, 0, 0, 0.9)',
          borderRadius: '8px',
          padding: '10px',
          maxWidth: '90%',
          maxHeight: '60vh',
          overflow: 'auto',
          backdropFilter: 'blur(10px)'
        }}>
          <div className='flex'>
            {test === 0 && (
              <div className='flex1'>
                {refRom1.length > 0 && <div className='item1' onClick={goRom1}>Тесты Ромберга 1</div>}
                {refRom2.length > 0 && <div className='item1' onClick={goRom2}>Тесты Ромберга 2</div>}
                {refs.length > 0 && <div className='item1' onClick={goRefs}>Глубокие рефлексы</div>}
                {mim.length > 0 && <div className='item1' onClick={goMim}>Мимика, менингеальные симптомы</div>}
                {cor.length > 0 && <div className='item1' onClick={goCor}>Координаторные пробы</div>}
              </div>
            )}
            {test === 1 && (
              <>
                {refRom1.map((el, idx) => (
                  <div key={idx} className='item' onClick={() => getAnim(el.name, 'rom1')}>{typeAnim(el.name)}</div>
                ))}
                <div className='item' onClick={() => resetAnim('rom1')}>Вернуться</div>
              </>
            )}
            {test === 2 && (
              <>
                {refRom2.map((el, idx) => (
                  <div key={idx} className='item' onClick={() => getAnim(el.name, 'rom2')}>{typeAnim(el.name)}</div>
                ))}
                <div className='item' onClick={() => resetAnim('rom2')}>Вернуться</div>
              </>
            )}
            {test === 3 && (
              <>
                {refs.map((el, idx) => (
                  <div key={idx} className='item' onClick={() => getAnim(el.name, 'refs')}>{typeAnim(el.name)}</div>
                ))}
                <div className='item' onClick={() => resetAnim('refs')}>Вернуться</div>
              </>
            )}
            {test === 4 && (
              <>
                {mim.map((el, idx) => (
                  <div key={idx} className='item' onClick={() => getAnim(el.name, 'mim')}>{typeAnim(el.name)}</div>
                ))}
                <div className='item' onClick={() => resetAnim('mim')}>Вернуться</div>
              </>
            )}
            {test === 5 && (
              <>
                {cor.map((el, idx) => (
                  <div key={idx} className='item' onClick={() => getAnim(el.name, 'cor')}>{typeAnim(el.name)}</div>
                ))}
                <div className='item' onClick={() => resetAnim('cor')}>Вернуться</div>
              </>
            )}
            {test === 6 && (
              <>
                {refLas.map((el, idx) => (
                  <div key={idx} className='item' onClick={() => getAnim(el.name, 'las')}>{typeAnim(el.name)}</div>
                ))}
                <div className='item' onClick={() => resetAnim('las')}>Вернуться</div>
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export default Model;